export default {
  alloyfactorLimitsLabel: 'Alloy factor limits',
  alloyFactorCFerrite: 'Alloy factor C (Ferrite)',
  alloyFactorCAustenite: 'Alloy factor C (Austenite)',
  alloyFactorNFerrite: 'Alloy factor N (Ferrite)',
  alloyFactorNAustenite: 'Alloy factor N (Austenite)',
  activityCoefficients: 'Activity coefficients',
};
